import type { CreateRegionalDto } from "@/dtos/CreateRegionalDto";
import type { UpdateRegionalDto } from "@/dtos/UpdateRegionalDto";
import api from "@/services/api";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useCreateRegional = () => {
  return useMutation({
    mutationKey: ["createRegional"],
    mutationFn: async ({
      sectorId,
      data,
    }: {
      sectorId: string;
      data: CreateRegionalDto;
    }) => {
      const response = await api.post(`/sectors/${sectorId}/regionals`, data);
      return response.data;
    },
  });
};

export const useGetRegionals = (sectorId: string) => {
  return useQuery({
    queryKey: ["getRegionals", sectorId],
    queryFn: async () => {
      const response = await api.get(`/sectors/${sectorId}/regionals`);
      return response.data;
    },
    enabled: !!sectorId,
  });
};

export const useGetRegionalById = (sectorId: string, regionalId: string) => {
  return useQuery({
    queryKey: ["getRegionalById", sectorId, regionalId],
    queryFn: async () => {
      const response = await api.get(`/sectors/regionals/${regionalId}`);
      return response.data;
    },
    enabled: !!sectorId && !!regionalId,
  });
};

export const useUpdateRegional = () => {
  return useMutation({
    mutationKey: ["updateRegional"],
    mutationFn: async ({
      sectorId,
      regionalId,
      data,
    }: {
      sectorId: string;
      regionalId: string;
      data: UpdateRegionalDto;
    }) => {
      const response = await api.patch(
        `/sectors/${sectorId}/regionals/${regionalId}`,
        data,
      );
      return response.data;
    },
  });
};

export const useDeleteRegional = () => {
  return useMutation({
    mutationKey: ["deleteRegional"],
    mutationFn: async ({ regionalId }: { regionalId: string }) => {
      const response = await api.delete(`/sectors/regionals/${regionalId}`);
      return response.data;
    },
  });
};
